import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';

import { MatSnackBar } from "@angular/material/snack-bar";
import { Subscription } from 'rxjs';

//SERVICE
import { DemographicService } from "../../services/demographics.service";
import { BroadcastTranslate } from '../broadcasttranslate.service';

import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector     : 'demo-translate',
    templateUrl  : './demotranslate.component.html',
    styleUrls    : ['./demotranslate.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class DemoTranslateComponent implements OnInit, OnDestroy
{
    animationDirection: 'left' | 'right' | 'none';
    course: any;
    courseStepContent: any;
    currentStep: number;
    idiomas: any;
    flagMensaje: boolean = false;
    demograficosArray: any;
    arregloIdiomaDemografico: any = [];
    subscription: Subscription;

    @ViewChildren(FusePerfectScrollbarDirective)
    fuseScrollbarDirectives: QueryList<FusePerfectScrollbarDirective>;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *

     * @param {ChangeDetectorRef} _changeDetectorRef
     * @param {FuseSidebarService} _fuseSidebarService
     */
    constructor(
        public snackBar: MatSnackBar,
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseSidebarService: FuseSidebarService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private demographicService: DemographicService,
        private broadcast: BroadcastTranslate) {
        // Set the defaults
        this.animationDirection = 'none';
        this.currentStep = 0;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        lang_certificar.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });

        this.subscription = this.broadcast.getEvent().subscribe(product => {
           console.log('ENTRANDO de native1...');
           this.obtenerDemograficos();
         });


    }


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

      this.course = [];


    }


    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Go to step
     *
     * @param step
     */
    gotoStep(step): void
    {
        // Decide the animation direction
        this.animationDirection = this.currentStep < step ? 'left' : 'right';

        // Run change detection so the change
        // in the animation direction registered
        this._changeDetectorRef.detectChanges();

        // Set the current step
        this.currentStep = step;
    }

    /**
     * Go to next step
     */
    gotoNextStep(): void
    {
        if ( this.currentStep === this.course.totalSteps - 1 )
        {
            return;
        }

        // Set the animation direction
        this.animationDirection = 'left';

        // Run change detection so the change
        // in the animation direction registered
        this._changeDetectorRef.detectChanges();

        // Increase the current step
        this.currentStep++;
    }

    /**
     * Go to previous step
     */
    gotoPreviousStep(): void
    {
        if ( this.currentStep === 0 )
        {
            return;
        }

        // Set the animation direction
        this.animationDirection = 'right';

        // Run change detection so the change
        // in the animation direction registered
        this._changeDetectorRef.detectChanges();

        // Decrease the current step
        this.currentStep--;
    }

    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void
    {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }

    openErrorSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
           duration: 15000,
           verticalPosition: 'bottom',
           panelClass: ['background-red']
        });
     }


     openSuccessSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
           duration: 15000,
           verticalPosition: 'top',
           panelClass: ['background-success']
        });
     }

     private obtenerDemograficos(){
       let data = {
         fechaCertificar: localStorage.getItem('fechaProducto')
       };
         this.demographicService.obtenerDemograficos(data)
         .subscribe(response => {

           console.log(response);
           if(response['message'] == 'Success'){
             this.flagMensaje = true;
             this.arregloIdiomaDemografico = response['arrayMostrar'];
           }else{
              this.flagMensaje = false;
           }

         }, error => {
           console.log("error", error);
         })
     }

     private saveQuestionTranslate(event,idDemografico,idiomaID){
       if(event.target.value.length > 0){
           let data = {
             fechaCertificar: localStorage.getItem('fechaProducto'),
             demograficoId: idDemografico,
             idiomaId: idiomaID,
             preguntaDemografico: event.target.value
           }

           this.demographicService.saveQuestionTranslate(data)
           .subscribe(response => {
               if(response['message'] == 'Success'){
                  this.openSuccessSnackBar('Question translate saved succesfully','OK');
               }


           }, error => {
             console.log("error", error);
           });
       }else{
         this.openErrorSnackBar('Please, insert the translate','OK');
       }
     }

     private saveOpcionTranslate(event,idDemografico,idiomaID,orden){
       if(event.target.value.length > 0){
           let data = {
             fechaCertificar: localStorage.getItem('fechaProducto'),
             demograficoId: idDemografico,
             idiomaId: idiomaID,
             ordenOpcion: orden,
             textoOpcion: event.target.value
           }

           this.demographicService.saveOpcionTranslate(data)
           .subscribe(response => {

             if(response['message'] == 'Success'){
                this.openSuccessSnackBar('Option translate saved succesfully','OK');
             }

           }, error => {
             console.log("error", error);
           });
       }else{
         this.openErrorSnackBar('Please, insert the translate','OK');
       }


     }



}
